/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusFaqDetailDto } from '../../models/lexplus-faq-detail-dto';
import { LexplusUpdateFaqDto } from '../../models/lexplus-update-faq-dto';

export interface FaqControllerUpdateV1$Params {
  id: number;
      body: LexplusUpdateFaqDto
}

export function faqControllerUpdateV1(http: HttpClient, rootUrl: string, params: FaqControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusFaqDetailDto>> {
  const rb = new RequestBuilder(rootUrl, faqControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusFaqDetailDto>;
    })
  );
}

faqControllerUpdateV1.PATH = '/v1/faq/{id}';
